module.exports = __webpack_public_path__ + "dc7a5afafee7bffceb338d5aaa3f7af1.png";